import { render } from "./bundleDetail.vue?vue&type=template&id=03a5a8b5"
import script from "./bundleDetail.vue?vue&type=script&lang=js"
export * from "./bundleDetail.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WSS-BuildAgent\\_work\\5\\s\\Sureload Admin\\sureload-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__